import * as React from 'react';
import { SVGProps } from 'react';

const IconHomeSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 14v7a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-7h1.993c.88 0 1.335-1.088.733-1.752l-8.993-9.92a.982.982 0 0 0-1.466 0l-8.993 9.92c-.602.665-.147 1.752.733 1.752H5Z" />
  </svg>
);
export default IconHomeSizeM;
